import { RoleHost } from '../RoleHost';

export function DEFWrapper() {
  return <RoleHost role="def" />;
}
